export const VeryfiedThird = ({
  width = '30',
  height = '30',
  fill = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_10160)">
        <path
          d="M28.4922 7.3501C28.4672 7.09802 28.3788 6.85638 28.235 6.64782C28.0912 6.43926 27.8969 6.27059 27.6702 6.1576L15.6702 0.157598C15.4618 0.0533167 15.232 -0.000976562 14.9989 -0.000976562C14.7659 -0.000976562 14.5361 0.0533167 14.3277 0.157598L2.32767 6.1576C2.10158 6.27123 1.90784 6.44011 1.76441 6.64857C1.62097 6.85703 1.53249 7.09833 1.50717 7.3501C1.49067 7.5106 0.0656695 23.5006 14.3907 29.8711C14.5821 29.9575 14.7897 30.0022 14.9997 30.0022C15.2097 30.0022 15.4173 29.9575 15.6087 29.8711C29.9337 23.5006 28.5087 7.5121 28.4922 7.3501V7.3501ZM14.9997 26.8456V15.0001H5.26467C4.68225 12.8676 4.40747 10.6628 4.44867 8.4526L14.9997 3.1771V15.0001H24.6897C23.5512 19.1101 20.9427 23.9686 14.9997 26.8456Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_19_10160">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
